import React from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  Button,
  VStack,
  Icon,
} from "@chakra-ui/react";
import { MdErrorOutline } from "react-icons/md";
import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <Container centerContent>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minH="80vh"
        textAlign="center"
      >
        <VStack spacing={6}>
          <Icon as={MdErrorOutline} w={32} h={32} color="orange.500" />
          <Heading
            fontSize={{ base: "4xl", md: "6xl" }}
            fontWeight="bold"
            color="gray.700"
          >
            404
          </Heading>
          <Heading
            fontSize={{ base: "xl", md: "2xl" }}
            fontWeight="semibold"
            color="gray.600"
          >
            Page Not Found
          </Heading>
          <Text
            fontSize={{ base: "md", md: "lg" }}
            color="gray.500"
            maxW="md"
            px={4}
          >
            Oops! The page you're looking for doesn't exist. It might have been
            moved or deleted.
          </Text>
          <Button
            colorScheme="orange"
            size="lg"
            onClick={() => navigate("/")}
            mt={4}
          >
            Go Back Home
          </Button>
        </VStack>
      </Box>
    </Container>
  );
};

export default NotFoundPage;
